var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg994393(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4398D1"
    },
    d: "M321.085,4.339l-52.068,69.424l52.068,69.424H512V4.339H321.085z M329.763,91.119 c-9.589,0-17.356-7.767-17.356-17.356s7.767-17.356,17.356-17.356c9.589,0,17.356,7.767,17.356,17.356 S339.352,91.119,329.763,91.119z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3F8FC4"
    },
    points: "512,35.597 357.176,143.186 512,143.186 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.847,
    y: 212.61,
    style: {
      fill: "#F9B44D"
    },
    width: 242.983,
    height: 216.949
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.305,
    y: 212.61,
    style: {
      fill: "#F77219"
    },
    width: 52.068,
    height: 52.068
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87CED9"
    },
    d: "M435.946,56.407h32.664V39.051h-17.356v-8.678h-17.356v8.886 c-10.622,1.085-18.354,10.578-17.269,21.2c0.677,6.604,4.695,12.401,10.639,15.351l22.84,11.42c1.015,0.495,1.441,1.727,0.937,2.742 c-0.338,0.694-1.041,1.137-1.805,1.145h-32.699v17.356h17.356v8.678h17.356v-8.886c10.622-1.085,18.354-10.578,17.269-21.2 c-0.677-6.604-4.695-12.401-10.639-15.351l-22.84-11.42c-1.015-0.495-1.441-1.727-0.937-2.742c0.338-0.694,1.041-1.137,1.805-1.145 H435.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4398D1"
    },
    d: "M420.881,264.678h-39.051v-17.356h39.051c16.775,0,30.373-13.598,30.373-30.373 s-13.598-30.373-30.373-30.373H234.305c-33.549,0-60.746-27.197-60.746-60.746s27.197-60.746,60.746-60.746h78.102v17.356h-78.102 c-23.96,0-43.39,19.43-43.39,43.39s19.43,43.39,43.39,43.39h186.576c26.364,0,47.729,21.365,47.729,47.729 S447.245,264.678,420.881,264.678z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7AA36"
    },
    points: "138.847,425.22 138.847,429.559 381.831,429.559 381.831,242.983 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC9A3"
    },
    d: "M338.441,420.881h-17.356c16.775,0,30.373-13.598,30.373-30.373l0,0l0,0 c0-16.775-13.598-30.373-30.373-30.373h-86.78c-37.636-21.513-83.855-21.513-121.492,0l0,0v147.525h225.627l157.418-94.451 C505.873,407.205,512,396.383,512,384.703l0,0c0-18.363-14.883-33.245-33.245-33.245l0,0h-1.831 c-5.45,0.009-10.813,1.345-15.62,3.914L338.441,420.881z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 360.136,
    style: {
      fill: "#4398D1"
    },
    width: 112.814,
    height: 147.525
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5B789"
    },
    d: "M338.441,429.559h-95.458c-4.79,0-8.678-3.888-8.678-8.678s3.888-8.678,8.678-8.678h95.458 c4.79,0,8.678,3.888,8.678,8.678S343.231,429.559,338.441,429.559z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 420.881,
    style: {
      fill: "#3F8FC4"
    },
    width: 112.814,
    height: 86.78
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#18588C"
    },
    cx: 60.746,
    cy: 455.593,
    r: 17.356
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg994393);
export default __webpack_public_path__ + "static/media/994393.5962f764a0a5bdf271fe20b384c14edf.svg";
export { ForwardRef as ReactComponent };